import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Card, CardContent, Typography, Grid, CircularProgress, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Edit, Trash2, Plus, X } from 'lucide-react';
import '../css/PostedJobs.css';

const MembersList = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchjobs = async () => {
      try {
        const res = await axios.get('/api/jobs');
        setJobs(res.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching members:", error);
        setLoading(false);
      }
    };

    fetchjobs();
  }, []);

  const handleToggleStatus = async (jobId, newStatus) => {
  try {
    const res = await axios.put(`/api/jobs/${jobId}/status`, {
      status: newStatus,
    });

    setJobs(prev =>
      prev.map(job =>
        job._id === jobId ? { ...job, status: res.data.status } : job
      )
    );
  } catch (error) {
    console.error('Status toggle error:', error.response?.data?.message || error.message);
    alert('Failed to update job status');
  }
};

const [editingJob, setEditingJob] = useState(null);
  const [formData, setFormData] = useState(null);

 const handleEdit = (job) => {
    setEditingJob(job);
    setFormData({ ...job });
  };

  // const handleDelete = (id) => {
  //   setJobs(jobs.filter(job => job._id !== id));
  //   console.log('Delete job:', id);
  // };
  const handleDelete = async (id) => {
    // Show confirmation dialog
    if (!window.confirm('Are you sure you want to delete this job? This action cannot be undone.')) {
      return;
    }

    try {
      const response = await fetch(`/api/jobs/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to delete job');
      }

      const data = await response.json();
      console.log('Job deleted successfully:', data);

      // Update local state - remove the deleted job
      setJobs(jobs.filter(job => job._id !== id));

      // Show success message
      alert('Job deleted successfully!');
    } catch (error) {
      console.error('Error deleting job:', error);
      alert('Error deleting job: ' + error.message);
    }
  };

  const handleFormChange = (field, value) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  
  const handleSave = async () => {
    try {
      // Show loading state
      const saveButton = document.querySelector('[data-save-button]');
      if (saveButton) {
        saveButton.disabled = true;
        saveButton.textContent = 'Saving...';
      }

      const response = await fetch(`/api/jobs/${formData._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          position: formData.position,
          summary: formData.summary,
          responsibilities: formData.responsibilities,
          education: formData.education,
          experience: formData.experience,
          skills: formData.skills,
          offer: formData.offer,
          location: formData.location,
          applydate: formData.applydate,
          status: formData.status,
        }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to update job');
      }

      const data = await response.json();
      console.log('Job updated successfully:', data);

      // Update local state with the response
      setJobs(jobs.map(job =>
        job._id === formData._id ? data.job : job
      ));

      // Close modal
      setEditingJob(null);
      setFormData(null);

      // Show success message (optional)
      alert('Job updated successfully!');
    } catch (error) {
      console.error('Error updating job:', error);
      alert('Error updating job: ' + error.message);
    } finally {
      // Reset button state
      const saveButton = document.querySelector('[data-save-button]');
      if (saveButton) {
        saveButton.disabled = false;
        saveButton.textContent = 'Save Changes';
      }
    }
  };

  const handleCloseModal = () => {
    setEditingJob(null);
    setFormData(null);
  };


  if (loading) return <CircularProgress />;

    const styles = {
    container: {
      padding: '24px',
      backgroundColor: '#f9fafb',
      minHeight: '100vh',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    contentCard: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      overflow: 'hidden',
    },
    cardHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '24px',
      borderBottom: '1px solid #e5e7eb',
      backgroundColor: '#ffffff',
    },
    cardTitle: {
      margin: 0,
      fontSize: '24px',
      fontWeight: '600',
      color: '#1f2937',
    },
    primaryButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '10px 18px',
      backgroundColor: '#059669',
      color: '#ffffff',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'all 0.3s ease',
    },
    jobCard: {
      display: 'grid',
      gridTemplateColumns: '1fr 180px',
      gap: '20px',
      padding: '20px 24px',
      borderBottom: '1px solid #f3f4f6',
      alignItems: 'start',
      transition: 'background-color 0.2s ease',
    },
    jobCardHover: {
      backgroundColor: '#f9fafb',
    },
    jobInfo: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    jobTitle: {
      margin: '0 0 12px 0',
      fontSize: '18px',
      fontWeight: '600',
      color: '#1f2937',
    },
    jobDetails: {
      margin: 0,
      fontSize: '13px',
      color: '#6b7280',
      lineHeight: '1.5',
    },
    statusControls: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      alignItems: 'flex-end',
    },
    statusBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      paddingLeft: '12px',
      paddingRight: '12px',
      paddingTop: '6px',
      paddingBottom: '6px',
      borderRadius: '6px',
      fontSize: '12px',
      fontWeight: '600',
      minWidth: '70px',
      textAlign: 'center',
    },
    actionButtons: {
      display: 'flex',
      gap: '8px',
      justifyContent: 'flex-end',
    },
    iconButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '36px',
      height: '36px',
      padding: 0,
      border: '1px solid #e5e7eb',
      borderRadius: '6px',
      backgroundColor: '#ffffff',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      color: '#6b7280',
    },
    editButton: {
      borderColor: '#3b82f6',
      color: '#3b82f6',
    },
    deleteButton: {
      borderColor: '#ef4444',
      color: '#ef4444',
    },
    toggleButton: {
      padding: '6px 12px',
      border: '1px solid',
      borderRadius: '6px',
      backgroundColor: '#ffffff',
      cursor: 'pointer',
      fontSize: '12px',
      fontWeight: '500',
      transition: 'all 0.2s ease',
    },
    emptyState: {
      padding: '48px 24px',
      textAlign: 'center',
      color: '#9ca3af',
    },
    // Modal styles
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    },
    modalContent: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 20px 25px rgba(0, 0, 0, 0.15)',
      maxWidth: '600px',
      width: '90%',
      maxHeight: '90vh',
      overflow: 'auto',
      position: 'relative',
    },
    modalHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '24px',
      borderBottom: '1px solid #e5e7eb',
      position: 'sticky',
      top: 0,
      backgroundColor: '#ffffff',
    },
    modalTitle: {
      margin: 0,
      fontSize: '20px',
      fontWeight: '600',
      color: '#1f2937',
    },
    closeButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '32px',
      height: '32px',
      padding: 0,
      border: 'none',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      color: '#6b7280',
      transition: 'all 0.2s ease',
    },
    modalBody: {
      padding: '24px',
    },
    formGroup: {
      marginBottom: '20px',
      display: 'flex',
      flexDirection: 'column',
    },
    formLabel: {
      fontSize: '14px',
      fontWeight: '500',
      color: '#374151',
      marginBottom: '8px',
    },
    formInput: {
      padding: '10px 12px',
      fontSize: '14px',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontFamily: 'inherit',
      transition: 'all 0.2s ease',
      boxSizing: 'border-box',
    },
    formInputFocus: {
      borderColor: '#3b82f6',
      outline: 'none',
      boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)',
    },
    modalFooter: {
      display: 'flex',
      gap: '12px',
      padding: '24px',
      borderTop: '1px solid #e5e7eb',
      backgroundColor: '#f9fafb',
      justifyContent: 'flex-end',
    },
    cancelButton: {
      padding: '10px 18px',
      border: '1px solid #d1d5db',
      backgroundColor: '#ffffff',
      color: '#374151',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'all 0.2s ease',
    },
    saveButton: {
      padding: '10px 18px',
      border: 'none',
      backgroundColor: '#3b82f6',
      color: '#ffffff',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'all 0.2s ease',
    },
  };

  return (
    //  <div style={styles.container}>
      <div className='ptjobcontentCard'>
        <div className='ptjobcardHeader'>
          <h3 className='ptjobcardTitle'>Job Listings</h3>
          <button
            //style={styles.primaryButton}
            onClick={() => navigate && navigate('/dashboard/postings/postjob')}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#047857'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#059669'}
            className='ptjobprimaryButton'
          >
            <Plus size={18} />
            Post New Job
          </button>
        </div>

        {jobs.length === 0 ? (
          <div className='ptjobemptyState'>
            <p>No job postings yet. Create one to get started!</p>
          </div>
        ) : (
          jobs.map((job) => (
            <div
              key={job._id}
              style={{
                //...styles.jobCard,
                //...(hoveredId === job._id ? styles.jobCardHover : {}),
              }}
              className='ptjobjobCard'
              //onMouseEnter={() => setHoveredId(job._id)}
              //onMouseLeave={() => setHoveredId(null)}
            >
              <div className='ptjobjobInfo'>
                <h4 className='ptjobjobTitle'>{job.position}</h4>
                <p className='ptjobjobDetails'>
                  <strong>Summary:</strong> {job.summary}
                </p>
                <p className='ptjobjobDetails'>
                  <strong>Responsibility:</strong> {job.responsibilities}
                </p>
                <p className='ptjobjobDetails'>
                  <strong>Education:</strong> {job.education}
                </p>
                <p className='ptjobjobDetails'>
                  <strong>Experience:</strong> {job.experience}
                </p>
                <p className='ptjobjobDetails'>
                  <strong>Skills:</strong> {job.skills}
                </p>
                <p className='ptjobjobDetails'>
                  <strong>Offer:</strong> {job.offer}
                </p>
                <p className='ptjobjobDetails'>
                  <strong>Location:</strong> {job.location}
                </p>
                <p className='ptjobjobDetails'>
                  <strong>Apply Before:</strong> {job.applydate}
                </p>
              </div>

              <div className='ptjobstatusControls'>
                <span
                  style={{
                    //...styles.statusBadge,
                    backgroundColor: job.status === 'active' ? '#dcfce7' : '#fef2f2',
                    color: job.status === 'active' ? '#065f46' : '#991b1b',
                  }}
                  className='ptjobstatusBadge'
                >
                  {job.status === 'active' ? 'Active' : 'Inactive'}
                </span>

                <button
                  style={{
                    //...styles.toggleButton,
                    backgroundColor: job.status === 'active' ? '#fef2f2' : '#dcfce7',
                    color: job.status === 'active' ? '#991b1b' : '#065f46',
                    borderColor: job.status === 'active' ? '#fca5a5' : '#86efac',
                  }}
                  className='ptjobtoggleButton'
                  onClick={() =>
                    handleToggleStatus(
                      job._id,
                      job.status === 'active' ? 'inactive' : 'active'
                    )
                  }
                  onMouseEnter={(e) => {
                    e.target.style.opacity = '0.8';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.opacity = '1';
                  }}
                >
                  Set {job.status === 'active' ? 'Inactive' : 'Active'}
                </button>

                <div className='ptjobactionButtons'>
                  <button
                    style={{
                      //...styles.iconButton,
                      //...styles.editButton,
                    }}
                    className='ptjobiconButton ptjobeditButton'
                    onClick={() => handleEdit(job)}
                    title="Edit job"
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#eff6ff';
                      e.target.style.borderColor = '#1e40af';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = '#ffffff';
                      e.target.style.borderColor = '#e5e7eb';
                    }}
                  >
                    <Edit size={18} />
                  </button>
                  <button
                    style={{
                      //...styles.iconButton,
                      ...styles.deleteButton,
                    }}
                    className='ptjobiconButton ptjobdeleteButton'
                    onClick={() => handleDelete(job._id)}
                    title="Delete job"
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#fef2f2';
                      e.target.style.borderColor = '#dc2626';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = '#ffffff';
                      e.target.style.borderColor = '#e5e7eb';
                    }}
                  >
                    <Trash2 size={18} />
                  </button>
                </div>
              </div>
            </div>
          ))
        )}


        {/* Edit Modal */}
      {editingJob && formData && (
        <div className='ptjobmodalOverlay' onClick={handleCloseModal}>
          <div
            //style={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
            className='ptjobmodalContent'
          >
            <div className='ptjobmodalHeader'>
              <h2 className='ptjobmodalTitle}'>Edit Job Posting</h2>
              <button
                style={styles.closeButton}
                onClick={handleCloseModal}
                className='ptjobcloseButton'
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f3f4f6';
                  e.target.style.color = '#1f2937';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#6b7280';
                }}
              >
                <X size={20} />
              </button>
            </div>

            <div className='ptjobmodalBody'>
              <div className='ptjobformGroup'>
                <label className='ptjobformLabel'>Position</label>
                <input
                  type="text"
                  //style={styles.formInput}
                  value={formData.position}
                  onChange={(e) => handleFormChange('position', e.target.value)}
                  onFocus={(e) => Object.assign(e.target.style, styles.formInputFocus)}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#d1d5db';
                    e.target.style.boxShadow = 'none';
                  }}
                  className='ptjobformInput'
                />
              </div>

              <div className='ptjobformGroup'>
                <label style={styles.formLabel} className='ptjobformLabel'>Summary</label>
                <textarea
                  style={{ minHeight: '80px', resize: 'vertical'}}
                  className='ptjobformInput'
                  value={formData.summary}
                  onChange={(e) => handleFormChange('summary', e.target.value)}
                  onFocus={(e) => Object.assign(e.target.style, styles.formInputFocus)}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#d1d5db';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </div>

              <div className='ptjobformGroup'>
                <label className='ptjobformLabel'>Responsibility</label>
                <textarea
                  style={{ minHeight: '80px', resize: 'vertical'}}
                  value={formData.responsibilities}
                  onChange={(e) => handleFormChange('responsibilities', e.target.value)}
                  onFocus={(e) => Object.assign(e.target.style, styles.formInputFocus)}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#d1d5db';
                    e.target.style.boxShadow = 'none';
                  }}
                  className='ptjobformInput'
                />
              </div>

              <div className='ptjobformGroup'>
                <label className='ptjobformLabel'>Education</label>
                <input
                  type="text"
                  style={styles.formInput}
                  value={formData.education}
                  onChange={(e) => handleFormChange('education', e.target.value)}
                  onFocus={(e) => Object.assign(e.target.style, styles.formInputFocus)}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#d1d5db';
                    e.target.style.boxShadow = 'none';
                  }}
                  className='ptjobformInput'
                />
              </div>

              <div className='ptjobformGroup'>
                <label className='ptjobformLabel'>Experience</label>
                <input
                  type="text"
                  //style={styles.formInput}
                  value={formData.experience}
                  onChange={(e) => handleFormChange('experience', e.target.value)}
                  onFocus={(e) => Object.assign(e.target.style, styles.formInputFocus)}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#d1d5db';
                    e.target.style.boxShadow = 'none';
                  }}
                  className='ptjobformInput'
                />
              </div>

              <div className='ptjobformGroup'>
                <label className='ptjobformLabel'>Skills</label>
                <textarea
                  style={{ minHeight: '80px', resize: 'vertical'}}
                  value={formData.skills}
                  onChange={(e) => handleFormChange('skills', e.target.value)}
                  onFocus={(e) => Object.assign(e.target.style, styles.formInputFocus)}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#d1d5db';
                    e.target.style.boxShadow = 'none';
                  }}
                  className='ptjobformInput'
                />
              </div>

              <div className='ptjobformGroup'>
                <label className='ptjobformLabel'>Offer</label>
                <input
                  type="text"
                  //style={styles.formInput}
                  value={formData.offer}
                  onChange={(e) => handleFormChange('offer', e.target.value)}
                  onFocus={(e) => Object.assign(e.target.style, styles.formInputFocus)}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#d1d5db';
                    e.target.style.boxShadow = 'none';
                  }}
                  className='ptjobformInput'
                />
              </div>

              <div className='ptjobformGroup'>
                <label className='ptjobformLabel'>Location</label>
                <input
                  type="text"
                  //style={styles.formInput}
                  value={formData.location}
                  onChange={(e) => handleFormChange('location', e.target.value)}
                  onFocus={(e) => Object.assign(e.target.style, styles.formInputFocus)}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#d1d5db';
                    e.target.style.boxShadow = 'none';
                  }}
                  className='ptjobformInput'
                />
              </div>

              <div className='ptjobformGroup'>
                <label className='ptjobformLabel'>Apply Date</label>
                <input
                  type="date"
                  //style={styles.formInput}
                  value={formData.applydate}
                  onChange={(e) => handleFormChange('applydate', e.target.value)}
                  onFocus={(e) => Object.assign(e.target.style, styles.formInputFocus)}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#d1d5db';
                    e.target.style.boxShadow = 'none';
                  }}
                  className='ptjobformInput'
                />
              </div>

              <div className='ptjobformGroup'>
                <label className='ptjobformLabel'>Status</label>
                <select
                  //style={styles.formInput}
                  className='ptjobformInput'
                  value={formData.status}
                  onChange={(e) => handleFormChange('status', e.target.value)}
                  // onFocus={(e) => Object.assign(e.target.style, styles.formInputFocus)}
                  // onBlur={(e) => {
                  //   e.target.style.borderColor = '#d1d5db';
                  //   e.target.style.boxShadow = 'none';
                  // }}
                  onFocus={(e) => e.target.classList.add('ptjobformInputFocus')}
                  onBlur={(e) => e.target.classList.remove('ptjobformInputFocus')}
                  
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
            </div>

            <div className='ptjobmodalFooter'>
              <button
                //style={styles.cancelButton}
                onClick={handleCloseModal}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#f3f4f6'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#ffffff'}
                className='ptjobcancelButton'
              >
                Cancel
              </button>
              <button
                style={styles.saveButton}
                className='ptjobsaveButton'
                onClick={handleSave}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
              >
                Save 
              </button>
            </div>
          </div>
        </div>
      )}
      </div>
    

    
  );
};

// const styles = {

//   contentCard: {
//     backgroundColor: 'white',
//     borderRadius: '8px',
//     boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
//     border: '1px solid #e5e7eb',
//     padding: '24px',
//     marginBottom: '24px'
//   },
//   cardHeader: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '16px'
//   },
//   cardTitle: {
//     fontSize: '18px',
//     fontWeight: '600',
//     margin: 0
//   },
//   primaryButton: {
//     padding: '8px 16px',
//     backgroundColor: '#2563eb',
//     color: 'white',
//     border: 'none',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     fontSize: '14px',
//     fontWeight: '500'
//   },
//     jobCard: {
//     border: '1px solid #e5e7eb',
//     borderRadius: '8px',
//     padding: '16px',
//     marginBottom: '12px',
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'flex-start'
//   },
//   jobInfo: {
//     flex: 1
//   },
//   jobTitle: {
//     fontWeight: '500',
//     margin: '0 0 4px 0'
//   },
//   jobDetails: {
//     fontSize: '14px',
//     color: '#6b7280',
//     margin: '0 0 4px 0'
//   },
//   jobMeta: {
//     fontSize: '14px',
//     color: '#9ca3af',
//     margin: 0
//   },
//   statusBadge: {
//     padding: '4px 8px',
//     backgroundColor: '#dcfce7',
//     color: '#065f46',
//     fontSize: '12px',
//     borderRadius: '9999px'
//   },
//   statusControls: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '12px',
//     marginTop: '8px',
//   },
//    toggleButton: {
//     padding: '6px 12px',
//     fontSize: '12px',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease-in-out',
//     backgroundColor: '#fef2f2',
//     color: '#991b1b',
//   },

// }

export default MembersList;
